export class ListDirectoryProtectionsError extends Error {}
